import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { CustomerListHeaderActions } from '../../pages/customer/shared/CustomerListHeaderActions';
import { ProjectListHeaderActions } from '../../pages/project/shared/ProjectListHeaderActions';
import { TaskListHeaderActions } from '../../pages/task/shared/TaskListHeaderActions';
import { GroupListHeaderActions } from '../../pages/group/shared/GroupListHeaderActions';
import { RecordsListHeaderActions } from '../../pages/settings/shared/RecordsListHeaderActions';
import { SettingsUsersListHeaderActions } from '../../pages/settings/shared/SettingsUsersListHeaderActions';
import { SupportListHeaderActions } from '../../pages/support/shared/SupportListHeaderActions';
import { getBreadcrumbItems, getHeaderByPath } from './pageHeaderConfig';

export const PageHeader = ({ title, section, subsection }) => {
    const { pathname, state } = useLocation();

    // Options passed down to the config helpers so dynamic labels resolve correctly
    const labelOptions = {
        customerDetailLabel: state?.customerName,
        projectDetailLabel:  state?.projectName,
        groupDetailLabel:    state?.groupName,
        ticketDetailLabel:   state?.ticketCode,
        userEditLabel:       state?.userName,
        // fallbacks from parent props (used when location.state is absent)
        title,
        section,
        subsection,
    };

    const currentHeader   = getHeaderByPath(pathname, labelOptions);
    const breadcrumbItems = getBreadcrumbItems(pathname, labelOptions);

    // ── Visibility guards ──────────────────────────────────────────────────────
    // Pages that render their own full-screen header or have no need for this bar
    const isDashboard    = pathname === '/' || pathname === '/home' || pathname === '/dashboard/tickets';
    const isTaskDetail   = pathname.startsWith('/tasks/detail/');

    if (isDashboard || isTaskDetail) {
        return null;
    }

    // ── Header action slots ────────────────────────────────────────────────────
    const isCustomerList = pathname === '/customer/list';
    const isProjectList  = pathname === '/project/list';
    const isTaskList     = pathname === '/tasks/list';
    const isGroupList    = pathname === '/group/list';
    const isRecordsList  = pathname === '/settings/records';
    const isUsersList    = pathname === '/settings/users';
    const isSupportList  = pathname === '/support';

    return (
        <div className="page-header">
            <div className="page-header-left d-flex align-items-center">
                <div className="page-header-title">
                    <h5 className="m-b-10">{currentHeader.title}</h5>
                </div>

                <ul className="breadcrumb">
                    {breadcrumbItems.map((item, index) => {
                        const isLast = index === breadcrumbItems.length - 1;

                        return (
                            <li className="breadcrumb-item" key={`${item.label}-${index}`}>
                                {!isLast && item.to ? (
                                    <Link to={item.to}>{item.label}</Link>
                                ) : (
                                    <span>{item.label}</span>
                                )}
                            </li>
                        );
                    })}
                </ul>
            </div>

            {isCustomerList && <CustomerListHeaderActions />}
            {isProjectList  && <ProjectListHeaderActions />}
            {isTaskList     && <TaskListHeaderActions />}
            {isGroupList    && <GroupListHeaderActions />}
            {isRecordsList  && <RecordsListHeaderActions />}
            {isUsersList    && <SettingsUsersListHeaderActions />}
            {isSupportList  && <SupportListHeaderActions />}
        </div>
    );
};
